import apiEndPoints from '../../utils/apiEndPoints'
import { apiCall } from '../../utils/httpClient';

const getBookingList = async (params) => {
    const data = await apiCall("post", apiEndPoints.GETBOOKINGLIST, params);
    return data;
};
const getBookingDetails = async (params) => {
    const data = await apiCall("post", apiEndPoints.GETBOOKINGDETAILS, params);
    return data;
};

const syncBookingToJW = async (params) => {
    const data = await apiCall("post", apiEndPoints.SYNCBOOKINGTOJW, params);
    return data;
};

const addBooking = async (params) => {
    const header = {
        "Content-Type": "multipart/form-data", "access-control-allow-origin": "*",
    };
    const data = await apiCall("post", apiEndPoints.ADDBOOKING, params, header);
    return data;
}

const bookingService = {
    getBookingList,
    getBookingDetails,
    syncBookingToJW,
    addBooking
};

export default bookingService;